import { render, staticRenderFns } from "./no-entity.vue?vue&type=template&id=50af6c75&lang=html&"
import script from "./no-entity.vue?vue&type=script&lang=js&"
export * from "./no-entity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports